export default "__VITE_ASSET__tsafvbp7__"